export class RolesNames {
    public static Admin: string = "Admin";
    public static Outros: string = "Outros";
    public static Paciente: string = "Paciente";
    public static ProfissionalSaude: string = "ProfissionalSaude";
    public static Clinica: string = "Clinica";
    public static Funcionario: string = "Funcionario";
}